// extracted by css-extract-rspack-plugin
export default {"bar":"DesbyN2thU5E0Yip","drawerNav":"e0acjyyB_P0YdiH2","drawer":"l7qIgmIgj9QeXPqO"};